/** Phase 7.7.4 — Solarent contractor contract page visual tokens */
export const CONTRACT_UX = {
  primary: "#005B8F",
  primaryDark: "#004A73",
  success: "#2E7D32",
  warning: "#F5A623",
  warningSoft: "rgba(245, 166, 35, 0.12)",
  bg: "#F7F9FC",
  cardBorder: "#E3E8EF",
  textMuted: "#5B6B7C",
  sectionGap: 2, // 16px — keep ≤ 24px between sections
  cardPadding: { xs: 1.75, md: 2 },
};
